import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
import LinkButton from 'flarum/common/components/LinkButton';
import BadgeCard from './BadgeCard';
import { distinctBadges, loadUserBadges } from '../utils';
import { t } from '../../../utils/settings';
/** Quantos cartões no resumo ("Melhores emblemas"). */
const LIMIT = 6;

/**
 * A seção "Melhores emblemas" da aba Resumo do perfil. Sem emblema
 * nenhum, a seção some: o resumo de quem acabou de chegar não precisa dela.
 */
export default class SummaryBadges extends Component {
  userBadges = null;
  oninit(vnode) {
    super.oninit(vnode);
    loadUserBadges(this.attrs.user).then(userBadges => {
      this.userBadges = userBadges;
      m.redraw();
    });
  }
  view() {
    if (!this.userBadges?.length) return null;
    const user = this.attrs.user;
    const badges = distinctBadges(this.userBadges);
    return m("section", {
      className: "CanelaUserSummary-section CanelaSummaryBadges"
    }, m("h2", {
      className: "CanelaUserSummary-heading"
    }, t('badges.summary_heading')), m("ul", {
      className: "CanelaBadges-grid CanelaBadges-grid--compact"
    }, badges.slice(0, LIMIT).map(({
      badge,
      count,
      latest
    }) => m("li", {
      key: badge.id()
    }, m(BadgeCard, {
      badge: badge,
      username: user.username(),
      timesGranted: count,
      grantedAt: latest.grantedAt()
    })))), badges.length > LIMIT && m(LinkButton, {
      className: "Button Button--link CanelaUserSummary-more",
      href: app.route('canela.user.badges', {
        username: user.slug()
      })
    }, t('badges.more_badges')));
  }
}
flarum.reg.add('ramon-canela', 'forum/features/badges/components/SummaryBadges', SummaryBadges);